import CloseIcon from '@/components/shared/icons/close-icon';
import { Box, Drawer, IconButton, Typography, useMediaQuery, useTheme } from '@mui/material';

const CustomDrawerSections = ({
    open,
    title,
    anchor = 'right',
    onClose,
    children,
    footer = null,
    contentProps = {},
    footerProps = {},
    paperSx = {},
    headerActions = null,
}) => {
    const theme = useTheme();
    const isMobile = useMediaQuery('(max-width: 576px)');

    if (!open) {
        return null;
    }

    const { sx: contentSx, ...restContentProps } = contentProps;
    const { sx: footerSx, ...restFooterProps } = footerProps;

    return (
        <Drawer
            anchor={anchor}
            open={open}
            onClose={onClose}
            transitionDuration={300}
            PaperProps={{
                sx: {
                    bgcolor: theme.palette.background.default,
                    height: '100dvh',
                    maxHeight: '100dvh',
                    width: '95%',
                    maxWidth: '600px',
                    display: 'flex',
                    flexDirection: 'column',
                    overflow: 'hidden',
                    position: 'fixed',
                    ...paperSx,
                },
            }}
        >
            <Box
                sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    bgcolor: theme.palette.background.darkCard,
                    padding: isMobile ? '8px' : '16px',
                    position: 'sticky',
                    top: 0,
                    zIndex: 9999,
                    height: '40px',
                    borderBottom: `1px solid ${theme.palette.border.main}`,
                    flexShrink: 0,
                }}
            >
                <Typography variant="h6" sx={{ fontWeight: 500 }}>
                    {title}
                </Typography>
                {headerActions ? (
                    headerActions
                ) : (
                    <IconButton onClick={onClose}>
                        <CloseIcon sx={{ color: theme.palette.footer.text }} />
                    </IconButton>
                )}
            </Box>

            <Box
                sx={{
                    flex: 1,
                    overflow: 'auto',
                    overscrollBehavior: 'contain',
                    p: isMobile ? 2 : 3,
                    minHeight: 0,
                    ...contentSx,
                }}
                {...restContentProps}
            >
                {children}
            </Box>

            {footer && (
                <Box
                    sx={{
                        borderTop: `1px solid ${theme.palette.border.main}`,
                        bgcolor: theme.palette.background.default,
                        p: isMobile ? 2 : 3,
                        flexShrink: 0,
                        ...footerSx,
                    }}
                    {...restFooterProps}
                >
                    {footer}
                </Box>
            )}
        </Drawer>
    );
};

export default CustomDrawerSections;
